import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Text } from 'apps/auth/components/common/Text/Text';
import { BLOCK_THREE_MONTH_LIMIT_ISSUE, MAX_AMOUNT_BONUS_ISSUE, MAX_AMOUNT_ISSUE } from 'apps/auth/constants/Constants';

import { Helper } from '../styles';

const getShortErrorInfoText = (errType, props) => {
    if (errType === MAX_AMOUNT_ISSUE) {
        return props.limitReached;
    } else if (errType === BLOCK_THREE_MONTH_LIMIT_ISSUE) {
        return props.limitReached;
    } else if (errType === MAX_AMOUNT_BONUS_ISSUE) {
        return props.messageText;
    }

    return props.viewDetails;
};

const GaErrorDetails = (props) => {
    const { messageText, amountField = {} } = props;
    return (
        <Helper>
            <Text size={props.errorMessage ? 'secondary' : 'main'} color="error">
                {messageText}
            </Text>
            {(amountField.isShowErrorDetails || props.isShowErrorDetails) && (
                <DiskButton
                    size="small"
                    iconName="info-rounded"
                    iconColor="error"
                    type="button"
                    raised={false}
                    onClick={props.onClick}
                    title={messageText}
                    dataTestId="view-details-link"
                />
            )}
        </Helper>
    );
};

const TransfersErrorDetails = (props) => {
    const { messageText, amountField = {} } = props;
    return (
        <Helper>
            {props.isShowErrorDetails ? (
                <>
                    <Text size="secondary" color="error">
                        {getShortErrorInfoText(amountField?.error?.code, props)}
                    </Text>
                    <DiskButton
                        size="small"
                        iconName="info-rounded"
                        iconColor="error"
                        type="button"
                        raised={false}
                        onClick={props.onClick}
                        dataTestId="view-details-link"
                    />
                </>
            ) : (
                <Text size={props.errorMessage ? 'secondary' : 'main'} color="error">
                    {messageText}
                </Text>
            )}
        </Helper>
    );
};

const ErrorDetails = (props) => {
    const messageText = props.errorMessage ? props.errorMessage : props.text;
    return props.isGaFlow ? <GaErrorDetails {...props} messageText={messageText} /> : <TransfersErrorDetails {...props} messageText={messageText} />;
};

ErrorDetails.propTypes = {
    onClick: PropTypes.func.isRequired,
    isShowErrorDetails: PropTypes.bool,
    isGaFlow: PropTypes.bool,
    text: PropTypes.string,
    errorMessage: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        limitReached: state.messages.pageMessages.limitReached,
        viewDetails: state.messages.pageMessages.viewDetails,
        youHave: state.messages.pageMessages.youHave,
        bonusAmountLimitReached: state.messages.pageMessages.bonusAmountLimitReached,
    };
};
export default connect(mapStateToProps)(ErrorDetails);
